(function() {
  'use strict';
  angular.module('ringbaPortal').controller('SelectDropdownController', SelectDropdownController);

  function SelectDropdownController(
    $scope,
    $filter,
    _
  ) {
    const vm = this;
    const optionValues = [],
      optionLabels = [];
    let ngModelController = null;

    vm.setSelectModel = setSelectModel;
    vm.selectedOptionLabel = null;
    vm.setNgModelController = setNgModelController;
    vm.applyFilter = applyFilter;
    vm.setTouchNgModel = setTouchNgModel;

    // Fill up array of options
    $scope.$watch('vm.options', function(newValue) {
      _.map(newValue, function (option) {
        optionValues.push((vm.valueProperty && option[vm.valueProperty]) || option);
        optionLabels.push(option[vm.labelProperty] || option['label'] || option);
      });
      renderViewValue();
    });


    function setSelectModel(option) {
      let value;
      if (vm.valueProperty && (option[vm.valueProperty] || option[vm.valueProperty] === null)) {
        value = option[vm.valueProperty];
      } else {
        value = option;
      }
      ngModelController.$setViewValue(value);
      try {
        vm.selectedOptionLabel = optionLabels[optionValues.indexOf(value)] || '';
      } catch {
        vm.selectedOptionLabel = '';
      }
    }

    // I set the ngModelController to be consumed by this component.
    function setNgModelController( newNgModelController ) {
      ngModelController = newNgModelController;
      // Setup our formatters to make sure the $viewValue is easy to
      // consume by the controller.
      // ngModelController.$formatters.push( formatModelValue );
      // Setup the render method to make sure the toggle is kept in
      // sync with the externally-changing ngModel binding.
      ngModelController.$render = renderViewValue;
    }

    function applyFilter(model, filterName, options, expression) {
      return (filterName && $filter(filterName)(model, options, expression)) || model;
    }

    function renderViewValue() {
      const value = ngModelController.$viewValue;
      try {
        vm.selectedOptionLabel = optionLabels[optionValues.indexOf(value)] || '';
      } catch {
        vm.selectedOptionLabel = '';
      }
    }

    function setTouchNgModel(open) {
      if (!open && !ngModelController.$touched) {
        ngModelController.$setTouched();
      }
    }

  }
})();
